import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import { calendlyTypeApi } from '@src/features/settings/pages/integration/services/get-calendly-types';
import { LeadCalendlyTypeFilterOptionItem } from './filter-option-item';
import type { TCalendlyType } from '@src/shared/types/calendly-types';

export const leadCalendlyTypeFilterConfig = createEntityFilterConfig({
  facetName: 'lead_source',
  fetchInfiniteData: calendlyTypeApi.useFetchInfinite,
  getValue: (item) => String(item.id),
  renderItem: LeadCalendlyTypeFilterOptionItem,
  entityType: STATIC_FILTER_ENTITY_TYPES.leadSource,
  transformItems: (items) => {
    return [
      { id: 'lead_form', name: 'Lead Form' } as unknown as TCalendlyType,
      ...items,
    ];
  },
});
